import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import routes from './routes';
import _ from 'lodash';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...routes,
    {
      path: '*',
      component: () => import(/* webpackChunkName: "404" */ '../views/NotFound.vue'),
    },
  ],
});

// This callback runs before every route change, including on page load.
router.beforeEach(function(to, from, next) {
  const is_authenticated = store.state.auth.authenticated;
  const requires_auth = to.matched.some((route) => _.get(route, 'meta.auth', false));

  // Check if the route requires authentication and user is not logged in

  if (requires_auth == true && is_authenticated == false) {
    if (from.hash == '') {
      return next({ name: 'SignIn' });
    }
    return next(false);
  }

  if (is_authenticated == true && to.name == 'SignIn') {
    return next({ name: 'home' });
  }
  next();
});

// Register global after hooks. Cannot affect the navigation
router.afterEach((to, from) => {
  // ...
});

export default router;
